<template>
  <div class="login-page"><br />
    <!-- Background with animated gradient -->
    <div class="login-background">
      <div class="gradient-overlay"></div>
      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
      </div>
    </div>

    <!-- Main Login Container -->
    <v-container class="login-container fill-height" fluid>
      <v-row justify="center" align="center" class="fill-height">
        <v-col cols="12" sm="11" md="10" lg="8" xl="7">
          <v-card class="login-card modern-card" elevation="24">
            <v-row no-gutters class="fill-height">
              <!-- Left Side - Branding -->
              <v-col cols="12" md="6" class="branding-section d-none d-md-flex">
                <div class="branding-content">
                  <div class="brand-header">
                    <div class="logo-container">
                      <v-icon class="brand-logo" size="60" color="white">mdi-account-heart</v-icon>
                    </div>
                    <h2 class="brand-title">சார்லட் தமிழ்ச் சங்கம்</h2>
                    <h2 class="brand-subtitle">Charlotte Tamil Sangam</h2>
                  </div>
                  
                  <div class="brand-description">
                    <p class="description-text">
                      Bringing together the vibrant Tamil community in Charlotte, promoting Tamil language, arts, and culture through unity and tradition.
                    </p>
                  </div>

                  <div class="brand-features">
                    <div class="feature-item">
                      <v-icon class="feature-icon" color="white">mdi-account-group</v-icon>
                      <span class="feature-text">Community Unity</span>
                    </div>
                    <div class="feature-item">
                      <v-icon class="feature-icon" color="white">mdi-book-open-variant</v-icon>
                      <span class="feature-text">Cultural Heritage</span>
                    </div>
                    <div class="feature-item">
                      <v-icon class="feature-icon" color="white">mdi-calendar-star</v-icon>
                      <span class="feature-text">Events & Programs</span>
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- Right Side - Login Form -->
              <v-col cols="12" md="6" class="form-section">
                <div class="form-container">
                  <!-- Header -->
                  <div class="form-header">
                    <div class="login-icon-container">
                      <img src="@/assets/login.png" class="login-icon" alt="Login"/>
                    </div>
                    <h2 class="form-title">Welcome Back</h2>
                    <p class="form-subtitle">Sign in to your account</p>
                  </div>

                  <!-- Login Form -->
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSignIn" class="login-form">
                    <!-- Email Field -->
                    <div class="input-group">
                      <v-text-field
                        name="email"
                        v-on:keyup="handleInputOnKeyup"
                        :rules="emailRules"
                        label="Email Address"
                        outlined
                        dense
                        class="modern-input"
                        id="email"
                        v-model="email"
                        type="email"
                        prepend-inner-icon="mdi-email-outline"
                        required
                        hide-details="auto"
                      ></v-text-field>
                    </div>

                    <!-- Password Field -->
                    <div class="input-group">
                      <v-text-field
                        name="password"
                        label="Password"
                        :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show3 ? 'text' : 'password'"
                        @click:append="show3 = !show3"
                        prepend-inner-icon="mdi-lock-outline"
                        class="modern-input"
                        id="password"
                        v-model="password"
                        outlined
                        dense
                        required
                        hide-details="auto"
                      ></v-text-field>
                    </div>

                    <!-- Remember Me & Forgot Password -->
                    <div class="form-options">
                      <v-checkbox
                        v-model="checkbox"
                        label="Remember me"
                        class="remember-checkbox"
                        hide-details
                      ></v-checkbox>
                      <a href="javascript:void(0)" @click="resetPassword()" class="forgot-link">
                        Forgot Password?
                      </a>
                    </div>

                    <!-- Sign In Button -->
                    <v-btn
                      color="primary"
                      class="signin-btn"
                      large
                      block
                      elevation="8"
                      @click="onSignIn"
                      :loading="loading"
                    >
                      <v-icon left>mdi-login</v-icon>
                      Sign In
                    </v-btn>

                    <!-- Error Alert -->
                    <v-alert
                      v-if="error"
                      class="error-alert"
                      type="error"
                      dense
                      outlined
                      dismissible
                      @click="onDismissed"
                    >
                      {{ getError(error) }}
                    </v-alert>
                  </v-form>

                  <!-- Sign Up Link -->
                  <div class="signup-section">
                    <p class="signup-text">
                      Don't have an account?
                      <a href="#/Signup" class="signup-link">Sign Up</a>
                    </p>
                  </div>

                  <!-- Social Login -->
                  <div class="social-section">
                    <v-divider class="social-divider"></v-divider>
                    <p class="social-text">Connect with us</p>
                    <div class="social-buttons">
                      <v-btn
                        class="social-btn facebook-btn"
                        href="https://www.facebook.com/cltts/"
                        target="_blank"
                        outlined
                        large
                      >
                        <v-icon left color="#1877F2">mdi-facebook</v-icon>
                        Facebook
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "FullLogin",
  data () {
    return {
      email: '',
      show3: false,
      password: '',
      checkbox: false,
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    }
  },
  computed: {
    formIsValid () {
      return this.email !== '' && this.password !== ''
    },
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    error () {
      return this.$store.getters.error
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/Successfull')
         setTimeout(() => {
          return this.$router.push('/userProfile')
        }, 200)
      }
    }
  },
  methods: {
    handleInputOnKeyup() {
      this.email = this.email.toLowerCase().trim()
    },
    getError (error) {
      if (error.includes("emailVerified")) {
        this.$store.dispatch('sendVerifyEmail')
          return 'You have not verified your email id'
       } else if (error.includes("record corresponding to this identifier")) {
          return 'Email id does not exists. Use sign-up to create new account.'
       } else return error
    },
    onSignIn () {
      if (!this.formIsValid) return
      let credentials = {
        email: this.email,
        password: this.password
      }
      this.$store.dispatch('signInAction', credentials)
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    resetPassword() {
      this.$router.replace('/Forgot')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

/* Animated Background */
.login-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  animation: gradientShift 8s ease-in-out infinite;
}

@keyframes gradientShift {
  0%, 100% {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  }
  50% {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 50%, #4facfe 100%);
  }
}

/* Floating Shapes */
.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 120px;
  height: 120px;
  top: 60%;
  right: 10%;
  animation-delay: 2s;
}

.shape-3 {
  width: 60px;
  height: 60px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

.shape-4 {
  width: 100px;
  height: 100px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* Main Container */
.login-container {
  position: relative;
  z-index: 1;
  padding: 20px;
}

/* Modern Card */
.login-card {
  border-radius: 20px !important;
  overflow: hidden !important;
  backdrop-filter: blur(20px) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15) !important;
  min-height: 600px;
  max-width: 1000px !important;
  width: 100% !important;
  margin: 0 auto !important;
  animation: cardSlideIn 0.8s ease-out;
}

@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Branding Section */
.branding-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  position: relative;
  overflow: hidden;
}

.branding-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.branding-content {
  position: relative;
  z-index: 1;
  padding: 50px 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.brand-header {
  margin-bottom: 30px;
}

.logo-container {
  margin-bottom: 20px;
}

.brand-logo {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 50% !important;
  padding: 15px !important;
  backdrop-filter: blur(10px) !important;
  animation: logoFloat 3s ease-in-out infinite;
}

@keyframes logoFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.brand-title {
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  color: white !important;
  margin-bottom: 8px !important;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.brand-subtitle {
  font-size: 1.2rem !important;
  font-weight: 400 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  margin-bottom: 0 !important;
}

.brand-description {
  margin-bottom: 30px;
}

.description-text {
  font-size: 1rem !important;
  line-height: 1.6 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  margin: 0 !important;
}

.brand-features {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.feature-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 25px !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s ease !important;
}

.feature-item:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: translateX(5px) !important;
}

.feature-icon {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 50% !important;
  padding: 6px !important;
}

.feature-text {
  font-size: 0.95rem !important;
  font-weight: 500 !important;
  color: white !important;
}

/* Form Section */
.form-section {
  background: white !important;
  display: flex !important;
  align-items: center !important;
}

.form-container {
  padding: 50px 40px;
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
}

.form-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-icon-container {
  margin-bottom: 20px;
}

.login-icon {
  width: 60px !important;
  height: 60px !important;
  border-radius: 50% !important;
  padding: 15px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3) !important;
  animation: iconPulse 2s ease-in-out infinite;
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
  }
}

.form-title {
  font-size: 2rem !important;
  font-weight: 700 !important;
  color: #2d3748 !important;
  margin-bottom: 8px !important;
}

.form-subtitle {
  font-size: 1rem !important;
  color: #718096 !important;
  margin: 0 !important;
}

/* Login Form */
.login-form {
  margin-top: 30px;
}

.input-group {
  margin-bottom: 20px;
}

.modern-input {
  border-radius: 12px !important;
}

.modern-input .v-input__control .v-input__slot {
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

.modern-input .v-input__control .v-input__slot:hover {
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.1) !important;
}

.modern-input.v-input--is-focused .v-input__control .v-input__slot {
  border-color: #667eea !important;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2) !important;
}

/* Form Options */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.remember-checkbox {
  margin: 0 !important;
}

.forgot-link {
  color: #667eea !important;
  text-decoration: none !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
  transition: all 0.2s ease !important;
}

.forgot-link:hover {
  color: #764ba2 !important;
  text-decoration: underline !important;
}

/* Sign In Button */
.signin-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  margin-bottom: 20px !important;
  transition: all 0.3s ease !important;
}

.signin-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4) !important;
}

.signin-btn:active {
  transform: translateY(0) !important;
}

/* Error Alert */
.error-alert {
  margin-top: 15px !important;
  border-radius: 8px !important;
}

/* Sign Up Section */
.signup-section {
  text-align: center;
  margin: 25px 0;
}

.signup-text {
  font-size: 0.95rem !important;
  color: #718096 !important;
  margin: 0 !important;
}

.signup-link {
  color: #667eea !important;
  text-decoration: none !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
}

.signup-link:hover {
  color: #764ba2 !important;
  text-decoration: underline !important;
}

/* Social Section */
.social-section {
  text-align: center;
  margin-top: 30px;
}

.social-divider {
  margin-bottom: 20px !important;
}

.social-text {
  font-size: 0.9rem !important;
  color: #718096 !important;
  margin-bottom: 15px !important;
}

.social-buttons {
  display: flex;
  justify-content: center;
}

.facebook-btn {
  border-color: #1877F2 !important;
  color: #1877F2 !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.facebook-btn:hover {
  background: #1877F2 !important;
  color: white !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(24, 119, 242, 0.3) !important;
}

/* Responsive Design */
@media (max-width: 960px) {
  .branding-section {
    display: none !important;
  }

  .form-container {
    padding: 30px 20px;
  }

  .form-title {
    font-size: 1.8rem !important;
  }

  .login-card {
    margin: 10px;
    min-height: auto;
  }
}

@media (max-width: 600px) {
  .login-container {
    padding: 10px;
  }

  .form-container {
    padding: 20px 15px;
  }

  .form-title {
    font-size: 1.6rem !important;
  }

  .signin-btn {
    font-size: 1rem !important;
  }
}
</style>
